// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"g-inline-editor_wrapper_YZ4U6","text":"g-inline-editor_text_2KRXo","input":"g-inline-editor_input_2yn5N"};